
<div class="po-row">
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    p-container
    [p-hide-select-all]="true"
    [p-striped]="true"
    [p-items]="tabelaArquivosItens"
    [p-columns]="tabelaArquivoColunas"
    [p-height]="300"
    p-hide-columns-manager="true"
    p-actions-right="true"
    [p-actions]="tabelaArquivoAction"
    p-spacing="small"
  ></po-table>
</div>
@if (habilitaUpload){
  <div class="po-sm-12 po-md-12 po-lg-12">
    <po-upload class="po-sm-12 po-md-12 po-lg-12"
      name="upload"
      [p-drag-drop]="true"
      [p-multiple]="true"
      [p-auto-upload]="true"
      [p-drag-drop-height]="5"
      [p-url]="urlUploadArquivo"
      [p-restrictions]="poUploadFileRestrictions"
      (p-success)="fileEnviadoSucesso($event)"
      p-label="Upload Arquivos."
    ></po-upload>
  </div>
}
